/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { Directive } from "@angular/core";
var WizardCustomTags = (function () {
    function WizardCustomTags() {
    }
    return WizardCustomTags;
}());
export { WizardCustomTags };
// No behavior
// The only purpose is to "declare" the tag in Angular
WizardCustomTags.decorators = [
    { type: Directive, args: [{ selector: "clr-wizard-title, clr-wizard-pagetitle" },] },
];
/** @nocollapse */
WizardCustomTags.ctorParameters = function () { return []; };
//# sourceMappingURL=wizard-custom-tags.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/wizard/wizard-custom-tags.js
// module id = 221
// module chunks = 4